import React from 'react';
import { useAppSelector } from '../app/hooks';
import { selectSignUp } from '../features/signup/signupSlice';
import { isCommunityFibrePlan } from '../features/finale/orderAPI';
import Picker from './Picker';
import ConnectionDate from './ConnectionDate';

export interface InstallationStepProps {
  onSubmit: () => void;
  previousStep: () => void;
}

/**
 * The installation step, which is not the same thing on the two networks. A
 * DGtek install needs an installer, so a time slot is booked with Arrivy;
 * Community Fibre connect the service themselves, so the customer picks a day
 * and nothing is booked.
 */
const InstallationStep = ({ onSubmit, previousStep }: InstallationStepProps) => {
  const signup = useAppSelector(selectSignUp);
  if (isCommunityFibrePlan(signup.plan)) {
    return <ConnectionDate onSubmit={onSubmit} previousStep={previousStep} />;
  }
  return <Picker onSubmit={onSubmit} previousStep={previousStep} />;
};

export default InstallationStep;
